import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import dlqE4ace5 from './dlq'
/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::index
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:131
* @route '/admin/whatsapp-instances'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/whatsapp-instances',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::index
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:131
* @route '/admin/whatsapp-instances'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::index
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:131
* @route '/admin/whatsapp-instances'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::index
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:131
* @route '/admin/whatsapp-instances'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::index
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:131
* @route '/admin/whatsapp-instances'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::index
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:131
* @route '/admin/whatsapp-instances'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::index
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:131
* @route '/admin/whatsapp-instances'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::create
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:167
* @route '/admin/whatsapp-instances/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/whatsapp-instances/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::create
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:167
* @route '/admin/whatsapp-instances/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::create
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:167
* @route '/admin/whatsapp-instances/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::create
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:167
* @route '/admin/whatsapp-instances/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::create
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:167
* @route '/admin/whatsapp-instances/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::create
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:167
* @route '/admin/whatsapp-instances/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::create
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:167
* @route '/admin/whatsapp-instances/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::store
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:230
* @route '/admin/whatsapp-instances'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/whatsapp-instances',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::store
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:230
* @route '/admin/whatsapp-instances'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::store
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:230
* @route '/admin/whatsapp-instances'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::store
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:230
* @route '/admin/whatsapp-instances'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::store
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:230
* @route '/admin/whatsapp-instances'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::show
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:299
* @route '/admin/whatsapp-instances/{instance}'
*/
export const show = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/whatsapp-instances/{instance}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::show
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:299
* @route '/admin/whatsapp-instances/{instance}'
*/
show.url = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { instance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { instance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            instance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        instance: typeof args.instance === 'object'
        ? args.instance.id
        : args.instance,
    }

    return show.definition.url
            .replace('{instance}', parsedArgs.instance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::show
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:299
* @route '/admin/whatsapp-instances/{instance}'
*/
show.get = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::show
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:299
* @route '/admin/whatsapp-instances/{instance}'
*/
show.head = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::show
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:299
* @route '/admin/whatsapp-instances/{instance}'
*/
const showForm = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::show
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:299
* @route '/admin/whatsapp-instances/{instance}'
*/
showForm.get = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::show
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:299
* @route '/admin/whatsapp-instances/{instance}'
*/
showForm.head = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::destroy
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:367
* @route '/admin/whatsapp-instances/{instance}'
*/
export const destroy = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/whatsapp-instances/{instance}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::destroy
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:367
* @route '/admin/whatsapp-instances/{instance}'
*/
destroy.url = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { instance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { instance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            instance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        instance: typeof args.instance === 'object'
        ? args.instance.id
        : args.instance,
    }

    return destroy.definition.url
            .replace('{instance}', parsedArgs.instance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::destroy
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:367
* @route '/admin/whatsapp-instances/{instance}'
*/
destroy.delete = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::destroy
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:367
* @route '/admin/whatsapp-instances/{instance}'
*/
const destroyForm = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::destroy
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:367
* @route '/admin/whatsapp-instances/{instance}'
*/
destroyForm.delete = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::connect
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:400
* @route '/admin/whatsapp-instances/{instance}/connect'
*/
export const connect = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: connect.url(args, options),
    method: 'post',
})

connect.definition = {
    methods: ["post"],
    url: '/admin/whatsapp-instances/{instance}/connect',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::connect
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:400
* @route '/admin/whatsapp-instances/{instance}/connect'
*/
connect.url = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { instance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { instance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            instance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        instance: typeof args.instance === 'object'
        ? args.instance.id
        : args.instance,
    }

    return connect.definition.url
            .replace('{instance}', parsedArgs.instance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::connect
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:400
* @route '/admin/whatsapp-instances/{instance}/connect'
*/
connect.post = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: connect.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::connect
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:400
* @route '/admin/whatsapp-instances/{instance}/connect'
*/
const connectForm = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: connect.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::connect
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:400
* @route '/admin/whatsapp-instances/{instance}/connect'
*/
connectForm.post = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: connect.url(args, options),
    method: 'post',
})

connect.form = connectForm

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::refreshStatus
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:455
* @route '/admin/whatsapp-instances/{instance}/refresh-status'
*/
export const refreshStatus = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refreshStatus.url(args, options),
    method: 'post',
})

refreshStatus.definition = {
    methods: ["post"],
    url: '/admin/whatsapp-instances/{instance}/refresh-status',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::refreshStatus
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:455
* @route '/admin/whatsapp-instances/{instance}/refresh-status'
*/
refreshStatus.url = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { instance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { instance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            instance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        instance: typeof args.instance === 'object'
        ? args.instance.id
        : args.instance,
    }

    return refreshStatus.definition.url
            .replace('{instance}', parsedArgs.instance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::refreshStatus
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:455
* @route '/admin/whatsapp-instances/{instance}/refresh-status'
*/
refreshStatus.post = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refreshStatus.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::refreshStatus
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:455
* @route '/admin/whatsapp-instances/{instance}/refresh-status'
*/
const refreshStatusForm = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refreshStatus.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::refreshStatus
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:455
* @route '/admin/whatsapp-instances/{instance}/refresh-status'
*/
refreshStatusForm.post = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refreshStatus.url(args, options),
    method: 'post',
})

refreshStatus.form = refreshStatusForm

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::syncContacts
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:564
* @route '/admin/whatsapp-instances/{instance}/sync-contacts'
*/
export const syncContacts = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: syncContacts.url(args, options),
    method: 'post',
})

syncContacts.definition = {
    methods: ["post"],
    url: '/admin/whatsapp-instances/{instance}/sync-contacts',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::syncContacts
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:564
* @route '/admin/whatsapp-instances/{instance}/sync-contacts'
*/
syncContacts.url = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { instance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { instance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            instance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        instance: typeof args.instance === 'object'
        ? args.instance.id
        : args.instance,
    }

    return syncContacts.definition.url
            .replace('{instance}', parsedArgs.instance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::syncContacts
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:564
* @route '/admin/whatsapp-instances/{instance}/sync-contacts'
*/
syncContacts.post = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: syncContacts.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::syncContacts
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:564
* @route '/admin/whatsapp-instances/{instance}/sync-contacts'
*/
const syncContactsForm = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: syncContacts.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::syncContacts
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:564
* @route '/admin/whatsapp-instances/{instance}/sync-contacts'
*/
syncContactsForm.post = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: syncContacts.url(args, options),
    method: 'post',
})

syncContacts.form = syncContactsForm

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::dlq
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:600
* @route '/admin/whatsapp-instances/{instance}/dlq'
*/
export const dlq = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dlq.url(args, options),
    method: 'get',
})

dlq.definition = {
    methods: ["get","head"],
    url: '/admin/whatsapp-instances/{instance}/dlq',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::dlq
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:600
* @route '/admin/whatsapp-instances/{instance}/dlq'
*/
dlq.url = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { instance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { instance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            instance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        instance: typeof args.instance === 'object'
        ? args.instance.id
        : args.instance,
    }

    return dlq.definition.url
            .replace('{instance}', parsedArgs.instance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::dlq
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:600
* @route '/admin/whatsapp-instances/{instance}/dlq'
*/
dlq.get = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dlq.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::dlq
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:600
* @route '/admin/whatsapp-instances/{instance}/dlq'
*/
dlq.head = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dlq.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::dlq
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:600
* @route '/admin/whatsapp-instances/{instance}/dlq'
*/
const dlqForm = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dlq.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::dlq
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:600
* @route '/admin/whatsapp-instances/{instance}/dlq'
*/
dlqForm.get = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dlq.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WhatsappInstancesController::dlq
* @see app/Http/Controllers/Admin/WhatsappInstancesController.php:600
* @route '/admin/whatsapp-instances/{instance}/dlq'
*/
dlqForm.head = (args: { instance: string | { id: string } } | [instance: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dlq.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dlq.form = dlqForm

const whatsappInstances = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    destroy: Object.assign(destroy, destroy),
    connect: Object.assign(connect, connect),
    refreshStatus: Object.assign(refreshStatus, refreshStatus),
    syncContacts: Object.assign(syncContacts, syncContacts),
    dlq: Object.assign(dlq, dlqE4ace5),
}

export default whatsappInstances